import { Component, AfterViewInit, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, NavigationStart, ActivatedRoute } from '@angular/router'
import { filter, take, takeUntil } from 'rxjs/operators';
import { PageHelperService } from './helpers/page-helper.service';
import { AuthService } from './security/auth.service';
import { CachedCustomerServiceService } from './services/cached-customer-service.service';
import { CustomerDto, DemoCustomerService } from 'src/shared/service-proxies/service-proxies';
import { LocalStorageService } from './services/local-storage.service';
import { SessionStorageService } from './services/session-storage.service';
import { ApplicationStatusService } from './services/application-status.service';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { CustomerSettings } from './services/customer-settings-service';
import { Location } from '@angular/common';

declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  title = 'app';
  userIsAdmin: boolean = false;
  userIsFinance: boolean = false;
  companies: CustomerDto[];
  selectedCompany: string = "Select Company";
  pageTitle = "Home";
  loading: boolean = false;
  isLoggedIn: boolean;
  isExpanded = false;
  activeSideBarItem = "";
  
  showBackButton: boolean = false;
  showLive:boolean = true;
  showActive:boolean = true;
  showInventry:boolean = true;
  showContainerRegistry:boolean = true;
  showServiceFrequency:boolean = true;
  showDamageReport:boolean = true;
  showKpi:boolean = true;
  showVehicleUtilisation:boolean = false;
  showKpiReports:boolean = false;
  showTippingActivityReport:boolean = false;
  showIntegrationReport:boolean = this.authService.userHasClaim("can_view_integration_report");
  showCollectionsReport:boolean = this.authService.userHasClaim("can_view_collections_report");
  showContainerAvailabilityReport:boolean = true;

  public companyCtrl: UntypedFormControl = new UntypedFormControl();
  public companyFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public filteredCompanies: ReplaySubject<CustomerDto[]> = new ReplaySubject(1);
  
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  protected _onDestroy = new Subject();
  
    // Constuctor
    constructor(
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private titleService: Title,
      private pageHelperService: PageHelperService,
      private authService: AuthService,
      private companyService: CachedCustomerServiceService,
      private localStorageService: LocalStorageService,
      private sessionStorageService: SessionStorageService,
      private applicationStatusService: ApplicationStatusService,
      private demoCustomerService: DemoCustomerService,
      private customerSettings: CustomerSettings,
      private location: Location) {
        this.pageHelperService.loading.subscribe(n => {
          this.loading = n
        });
        authService.isAdmin().then(isAdmin => {
          if (isAdmin) {
            this.showVehicleUtilisation = true;
            this.showKpiReports = true;
            this.showTippingActivityReport = true;
          }
          else {
            authService.hasClaim("can_view_tipping_activity_report").subscribe(hasTipping => {
              if (hasTipping) {
                this.showLive = true;
                this.showActive = true;
                this.showInventry = true;
                this.showContainerRegistry = true;
                this.showServiceFrequency = false;
                this.showDamageReport = false;
                this.showKpi = false;
                this.showVehicleUtilisation = false;
                this.showKpiReports = false;
                this.showTippingActivityReport = true;
                this.showContainerAvailabilityReport = false;
              } else {
                authService.hasClaim("is_yabby_only_user").subscribe(isYabby => {
                  if (isYabby) {
                    this.showLive = false;
                    this.showActive = false;
                    this.showInventry = true;
                    this.showContainerRegistry = true;
                    this.showServiceFrequency = true;
                    this.showDamageReport = true;
                    this.showKpi = false;
                    this.showVehicleUtilisation = false;
                    this.showKpiReports = false;
                    this.showTippingActivityReport = false;
                    this.showContainerAvailabilityReport = false;
                  }
                  else {
                      authService.hasClaim("is_container_only_user").subscribe(isContainer => {
                      if (isContainer) {
                        this.showLive = false;
                        this.showActive = false;
                        this.showInventry = false;
                        this.showContainerRegistry = true;
                        this.showServiceFrequency = false;
                        this.showDamageReport = false;
                        this.showKpi = false;
                        this.showVehicleUtilisation = false;
                        this.showKpiReports = false;
                        this.showTippingActivityReport = false;
                        this.showContainerAvailabilityReport = false;
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }

    ngOnInit() {
       this.router.events.pipe(
          filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
          const rt = this.getChild(this.activatedRoute);
          const data = rt.snapshot.data;
          this.titleService.setTitle(data.title);
          this.pageTitle = data.title;
          this.setActiveSideBarItem();
          if (data.showBack) {
            this.showBackButton = true;
          } else {
            this.showBackButton = false;
          }
          gtag('config', 'G-9RW95JT8PE',
                  {
                      page_path: event.urlAfterRedirects
                  }
          );
          gtag('config', 'GA_MEASUREMENT_ID', {
            'user_id': ""
          });            
        });

        this.pageHelperService.pageTitleSubscription.subscribe(t => {
          this.titleService.setTitle(t)
          this.pageTitle = t;
        });
  
      this.companyFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCustomers();
        });

      // Filter companies as user types in autocomplete
      this.companyCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(value => {
          if (typeof value === 'string') {
            this.filterCompaniesByString(value);
          }
        });

      let pinLoaded = sessionStorage.getItem('pinLoaded');
      
      if  (!pinLoaded) {
        sessionStorage.setItem('pinLoaded', 'true');
      }

      /*
      if (!pinLoaded || this.router.navigated) {
        this.navigateHome();
      }
      */
    }

    navigateHome() {
      if (this.authService.userHasClaim("set_home_page_to_depot_details")) {
        this.router.navigate(['/depot-details/home']);
      }
      else {
        this.router.navigate(['/']);
      }
    }

    ngAfterViewInit() {
      this.authService.isSignedIn().then(result => {
        this.isLoggedIn = result;
        if (result) {
          this.authService.isAdmin().then(result => {
            this.userIsAdmin = result == null ? false : result;
            this.userIsFinance =  result == null ? false : this.authService.isFinanceUser();
            this.companyService.getAll().then(data => {
              this.companies = data;
              this.companyCtrl.setValue(this.companies[1]);
              this.filteredCompanies.next(this.companies.slice());

              // TODO: TBP-807 Non admin users should not need to call this end point
              if (this.selectedCompany == "Select Company" && this.companies.length > 1) {
                var storedCompany = this.localStorageService.getItem("selectedCompany");
                var company = storedCompany == null || storedCompany == "" 
                  ? this.companies[0] 
                  : this.companies.find(c => c.id == storedCompany);
                this.selectedCompany = company.name;
                this.companyCtrl.setValue(company);
                this.pageHelperService.setSelectedCompanyId(company.id);
                this.customerSettings.loadCustomerSettings(company.id);
              } else {
                var company = this.companies[0];
                this.selectedCompany = company.name;
                this.companyCtrl.setValue(company);
                this.pageHelperService.setSelectedCompanyId(company.id);
              }
              
              this.applicationStatusService.setIsInitialised(true);
            });
          });
          this.authService.getUser().then(user => {
            if (user != null) {
              let userId = user.isAdmin ? "admin" : user.customerId;
              gtag('set', {'user_id': userId});
              console.log("set gtag: " + userId)
            }
          })
        } else {
          window.location.href = AuthService.userManagerSettings.loginUrl;
        }
      }).catch(reason => {
        console.log(reason);
      });
    }

    ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
    }

    makeDemoCustomer() {
      this.demoCustomerService.setDemoCustomer(this.selectedCompany).subscribe(result => {
        this.setCompany(this.companies.filter(c => c.name == "DemoCustomer")[0])
        window.location.reload();
      });
    }

    displayCompany(company: CustomerDto): string {
      return company && company.name ? company.name : '';
    }

    selectCompany(company: CustomerDto) {
      if (!company) return;
      this.setCompany(company);
    }

    setCompany(company: CustomerDto) {
      this.selectedCompany = company.name;
      this.sessionStorageService.clear()
      this.pageHelperService.setSelectedCompanyId(company.id);
      this.localStorageService.setItem("selectedCompany", company.id);
      this.customerSettings.loadCustomerSettings(company.id);
    }

    getChild(activatedRoute: ActivatedRoute) {
      if (activatedRoute.firstChild) {
        return this.getChild(activatedRoute.firstChild);
      } else {
        return activatedRoute;
      }
    }

    logout() {
      this.authService.logout();
    }

    protected setInitialValue() {
      this.filteredCompanies
        .pipe(take(1), takeUntil(this._onDestroy))
        .subscribe(() => {
            this.singleSelect.compareWith = (a: CustomerDto, b: CustomerDto) => a && b && a.id === b.id;
        });
    }
    

    protected filterCustomers() {
      if (!this.companies) {
        return;
      }
    
      let search = this.companyFilterCtrl.value;
      if (!search) {
        this.filteredCompanies.next(this.companies.slice());
        return;
      } else {
        search = search.toLowerCase();
      }
    
      this.filteredCompanies.next(
        this.companies.filter(bank => bank.name.toLowerCase().indexOf(search) > -1)
      );
    }

    protected filterCompaniesByString(searchText: string) {
      if (!this.companies) {
        return;
      }
      
      if (!searchText) {
        this.filteredCompanies.next(this.companies.slice());
        return;
      }
      
      searchText = searchText.toLowerCase();
      this.filteredCompanies.next(
        this.companies.filter(company => company.name.toLowerCase().indexOf(searchText) > -1)
      );
    }

    toggleSidebar(){
      this.isExpanded = !this.isExpanded 
    }

    onMenuHover(event: MouseEvent) {
      const hoveredElement = event.target as HTMLElement;
      const dropdownElement = hoveredElement.querySelector('[data-bs-toggle="dropdown"]') as HTMLElement;
      const menuElement = hoveredElement.querySelector('.dropdown-menu') as HTMLElement;
      dropdownElement.setAttribute("aria-expanded", "true")
      menuElement.classList.add('show');
      menuElement.setAttribute("data-bs-popper", "none")
    }
    
    onMenuLeave(event: MouseEvent) {
      const hoveredElement = event.target as HTMLElement;
      const dropdownElement = hoveredElement.querySelector('[data-bs-toggle="dropdown"]') as HTMLElement;
      const menuElement = hoveredElement.querySelector('.dropdown-menu') as HTMLElement;
      dropdownElement.removeAttribute("data-bs-popper");
      menuElement.classList.remove('show');
      menuElement.removeAttribute("aria-expanded")
    }

    setActiveSideBarItem(){
      switch(this.pageTitle){
        case "Live Operations":
          this.activeSideBarItem = "Operations"
          break;
        case "Active Operations":
          this.activeSideBarItem = "Operations"
          break;
        case "Container Inventory":
          this.activeSideBarItem = "Containers"
          break;
        case "Container Register":
          this.activeSideBarItem = "Containers"
          break;
        case "Damage Report":
          this.activeSideBarItem = "Containers"
          break;
        case "Service Frequency":
          this.activeSideBarItem = "Customers"
          break;
        case "Reports":
          this.activeSideBarItem = "Customers"
          break;
        case "Integration Report":
          this.activeSideBarItem = "Customers"
          break;
        case "Collections":
          this.activeSideBarItem = "Customers"
          break;
        case "Alerts":
          this.activeSideBarItem = "Admin"
          break;
        case "Yabby Devices":
          this.activeSideBarItem = "Admin"
          break;
        case "Billing Summary":
          this.activeSideBarItem = "Finance"
          break;
        case "Billing Details":
          this.activeSideBarItem = "Finance"
          break;
      }
    }

    goBack() {
      this.location.back();
    }
}
